import { useEffect, useRef } from "react";
import styled from "styled-components";

const PaymentRedirect = ({ paymentData, onError }) => {
  const formRef = useRef(null);
  const hasSubmitted = useRef(false);

  useEffect(() => {
    // Auto-submit form when payment data is received
    if (paymentData && formRef.current && !hasSubmitted.current) {
      hasSubmitted.current = true;
      console.log("🚀 Redirecting to payment gateway...");

      // Small delay to ensure form is rendered
      setTimeout(() => {
        try {
          formRef.current.submit();
        } catch (error) {
          console.error("Form submit error:", error);
          onError?.("Greška pri preusmeravanju na plaćanje");
        }
      }, 100);
    }
  }, [paymentData, onError]);

  if (!paymentData) {
    return null;
  }

  return (
    <Container translate="no">
      <LoadingMessage>
        <Spinner />
        <h3>Preusmeravanje na sigurno plaćanje...</h3>
        <p>Molimo sačekajte, preusmeravamo vas na Raiffeisen banku.</p>
      </LoadingMessage>

      {/* Hidden form that submits to payment gateway */}
      <form
        ref={formRef}
        action={paymentData.gatewayUrl}
        method="POST"
        style={{ display: "none" }}
      >
        <input type="hidden" name="Version" value={paymentData.Version} />
        <input type="hidden" name="MerchantID" value={paymentData.MerchantID} />
        <input type="hidden" name="TerminalID" value={paymentData.TerminalID} />
        <input
          type="hidden"
          name="TotalAmount"
          value={paymentData.TotalAmount}
        />
        <input type="hidden" name="Currency" value={paymentData.Currency} />
        <input type="hidden" name="locale" value={paymentData.locale} />
        <input
          type="hidden"
          name="PurchaseTime"
          value={paymentData.PurchaseTime}
        />
        <input type="hidden" name="OrderID" value={paymentData.OrderID} />
        <input
          type="hidden"
          name="PurchaseDesc"
          value={paymentData.PurchaseDesc}
        />
        <input type="hidden" name="Delay" value={paymentData.Delay} />
        <input type="hidden" name="Signature" value={paymentData.Signature} />
      </form>
    </Container>
  );
};

// Styled Components
const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.95);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;

const LoadingMessage = styled.div`
  text-align: center;
  padding: 40px;

  h3 {
    margin: 20px 0 10px;
    color: #333;
    font-size: 24px;
  }

  p {
    color: #666;
    font-size: 16px;
  }
`;

const Spinner = styled.div`
  width: 60px;
  height: 60px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #ffd700;
  border-radius: 50%;
  margin: 0 auto;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export default PaymentRedirect;
